import React from 'react';
import styles from './ComposicaoFamiliar.module.css';
import { selectFamilia } from '../exclusaoCadastralSlice';
import { useAppSelector } from '../../../app/hooks';
import { tiposRelacaoParentesco } from '../../../common/enum';
import { obterNomePessoa } from '../../../common/perfilUtils';

const ComposicaoFamiliar: React.FC<any> = () => {
  const familia = useAppSelector(selectFamilia);

  const obterValueRelacaoParentesco = (integrante: any) => {
    const rp = tiposRelacaoParentesco.find(
      (relacaoParentesco) => relacaoParentesco.value === integrante?.tipoRelacaoParentescoRF?.codigo
    );
    return rp ? rp.label : '';
  };

  const divIntegrantesFamilia = () => {
    let listaIntegrantes = familia?.integranteFamiliaDTOs?.slice();

    const integrantes = listaIntegrantes.sort((a, b) => {
      return a.tipoRelacaoParentescoRF.codigo - b.tipoRelacaoParentescoRF.codigo;
    });

    return integrantes?.map((integrante, index) => {
      return (
        <div key={index} className={styles.blocoItem}>
          <i className={`fas fa-user`}></i>
          <div className={styles.blocoItemLeft}>
            <span className={styles.itemText}>{obterNomePessoa(integrante.pessoaDadosCadastroDTO)}</span>
            <br />
            <span className={styles.itemTextSecondary}>
              {obterValueRelacaoParentesco(integrante)}
            </span>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className={styles.cardHeader}>
        <i className={`fas fa-home ${styles.cardIcon}`}></i>
        <span className={styles.cardHeaderTitle}>Composição familiar</span>
      </div>
      {divIntegrantesFamilia()}
    </>
  );
};

export default ComposicaoFamiliar;
